import { Col, Row, TabPanel } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { Typography } from '@paypalcorp/ppods-react'
import React from 'react'

import StandardCheckoutImg from '../../../../img/payment-solutions/ill_StandardCheckout.png'
import SubscriptionsImg from '../../../../img/payment-solutions/ill_Subscriptions.png'
import InvoicingImg from '../../../../img/payment-solutions/ill_Invoicing.png'
import { saveBannerProgress } from '../../../../utils/session-utils'
import { useApplicationContext } from '../../../../context/ApplicationContext'

export default function Online({ setBannerPage, setProductIntegration }) {
  const { csrf, logger, setCurrentBannerStep } = useApplicationContext()
  return (
    <>
      <TabPanel id="group4-panel2" tabId="group1-panel2">
        <Row className="onboarding-banner-cards-row">
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'stdCheckout',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setCurrentBannerStep(sessionObject)
                setBannerPage(1)
                setProductIntegration('stdCheckout')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={StandardCheckoutImg}
              />
              <br />
              <Typography variant="title" style={{ margin: 0 }}>
                <strong>
                  <Message id="onboarding-banner.tabTwo.productOne" />
                </strong>
              </Typography>
              <Typography variant="body" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabTwo.productOneDesc" />
              </Typography>
            </div>
          </Col>
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'subscriptions',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('subscriptions')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={SubscriptionsImg}
              />
              <br />
              <Typography variant="title" style={{ margin: 0 }}>
                <strong>
                  <Message id="onboarding-banner.tabTwo.productTwo" />
                </strong>
              </Typography>
              <Typography variant="body" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabTwo.productTwoDesc" />
              </Typography>
            </div>
          </Col>
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'invoicing',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('invoicing')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={InvoicingImg}
              />
              <br />

              <Typography variant="title" style={{ margin: 0 }}>
                <strong>
                  <Message id="onboarding-banner.tabTwo.productThree" />
                </strong>
              </Typography>
              <Typography variant="body" style={{ margin: 0 }}>
                <Message id="onboarding-banner.tabTwo.productThreeDesc" />
              </Typography>
            </div>
          </Col>
        </Row>
      </TabPanel>
    </>
  )
}
